import Bugsnag from "@bugsnag/js";
import Router from "next/router";
import { loanApplicationService } from "@/modules/client/loan-application/store/services/loan-application-service";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import BORROWER_LOAN_ORIGINATION from "@/modules/client/loan-application/events";

const sendApplication = loanApplicationService.injectEndpoints({
  endpoints: builder => ({
    sendApplication: builder.mutation({
      query: ({ organizationId: id, ...body }) => ({
        url: `organizations/${id}/loan-origination`,
        method: "POST",
        body,
      }),
      async onQueryStarted({ organizationId }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(BORROWER_LOAN_ORIGINATION.APPLICATION_SUBMITTED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Your application has been submitted.",
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );

          Router.push(`/organizations/${organizationId}/loan-application/submitted`);
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useSendApplicationMutation } = sendApplication;

